// extracted by mini-css-extract-plugin
export default {"explanation":"Explanation_explanation__AYGWX","caution":"Explanation_caution__ODvtD"};